<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
    @open="handleOpen"
    class="mini-dialog"
  >
    <el-form :model="formData" label-width="160px" :rules="formRules" ref="formRef">
      <el-form-item label="序号" prop="seqNo">
        <el-input v-model.number="formData.seqNo" :disabled="operateType === 'read'"  oninput="value = value.replace(/[^\d]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="标签编码" prop="code">
        <el-input v-model="formData.code" :disabled="operateType === 'read'"></el-input>
      </el-form-item>
      <el-form-item label="标签名称" prop="name">
        <el-input v-model="formData.name" :disabled="operateType === 'read'"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="text-center" v-if="operateType !== 'read'">
      <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { LableApi } from '@wiz-api/cloud-render-management'

const labelApi = new LableApi()
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    operateProps: {
      type: Object,
      default: () => {},
    },
    operateType: {
      type: String,
      default: 'create',
    },
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        seqNo: '',
        code: '',
        name: '',
      },
      formRules: {
        seqNo: { required: true, message: '请输入序号', trigger: 'blur' },
        code: { required: true, message: '请输入标签编码', trigger: 'blur' },
        name: { required: true, message: '请输入标签名称', trigger: 'blur' },
      },
    }
  },
  computed: {
    title() {
      switch (this.operateType) {
        case 'create':
          return '新增'
        case 'read':
          return '查看'
        default:
          return '编辑'
      }
    },
  },
  methods: {
    // 保存
    save() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          this.saveLoading = true
          let err = null
          let res = {}
          if (_.isEmpty(this.operateProps)) {
            // 新增
            ;[err, res] = await labelApi.create({
              body: {
                seqNo: this.formData.seqNo,
                code: this.formData.code,
                name: this.formData.name,
              },
            })
          } else {
            // 编辑
            ;[err, res] = await labelApi.update(this.operateProps.id, { body: this.formData })
          }
          if (!err && res) {
            this.$message({
              showClose: true,
              message: '保存成功',
              type: 'success',
            })
            this.$emit('update:visible', false)
            this.$emit('refresh')
          }
          this.saveLoading = false
        }
      })
    },
    // 关闭弹框
    handleClose() {
      this.$refs.formRef.resetFields()
      this.formData = this.$options.data().formData
      this.$emit('update:visible', false)
    },
    // 打开弹框
    handleOpen() {
      if (!_.isEmpty(this.operateProps)) {
        this.formData = _.cloneDeep(this.operateProps)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  .el-input,
  .el-select,
  .el-input-number {
    max-width: 440px;
    width: 100%;
    line-height: 36px;
    .el-input__inner {
      text-align: left;
    }
    .el-input-number__decrease {
      line-height: 18px;
    }
    .el-input-number__increase {
      line-height: 17px;
    }
  }
}
</style>
